import { render, staticRenderFns } from "./moveBarFloor.vue?vue&type=template&id=197f5b86&scoped=true&"
import script from "./moveBarFloor.vue?vue&type=script&lang=js&"
export * from "./moveBarFloor.vue?vue&type=script&lang=js&"
import style0 from "./moveBarFloor.vue?vue&type=style&index=0&id=197f5b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f5b86",
  null
  
)

export default component.exports